import React from "react";
import CardComex from "./CardComex";
import TinySlider from "tiny-slider-react";

import "swiper/css";

export default function TestimoniosComex({ testimonios, color }) {
  const settings = {
    container: "",
    items: 3,
    controls: true,
    mouseDrag: true,
    loop: true,
    rewind: true,
    animateOut: "rollOut",
    autoplay: false,
    autoplayButtonOutput: false,
    autoplayTimeout: 3000,
    navPosition: "bottom",
    controlsText: [
      '<i class="mdi mdi-chevron-left "></i>',
      '<i class="mdi mdi-chevron-right"></i>',
    ],
    nav: true,
    speed: 1000,
    gutter: 32, // Aumenta la separación entre tarjetas
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  };
  return (
    <section
      className={`w-full ${color} flex flex-col items-center justify-center`}
    >
      <h2 className="text-left mt-[100px] container w-full text-3xl md:text-4xl lg:text-5xl font-extrabold text-sidom-orange mb-[60px] ">
        Testimonios
      </h2>
      <div className="container mb-[100px]">
        <div className="dark:bg-sidom-blue">
          <TinySlider settings={settings}>
            {testimonios?.map((t, idx) => (
              <div className="px-3" key={t.id}>
                {" "}
                {/* Espaciado horizontal extra */}
                <CardComex
                  img={
                    t.img?.[0]?.formats?.thumbnail?.url
                      ? `${t.img[0].formats.thumbnail.url}`
                      : t.img?.[0]?.url
                      ? `${t.img[0].url}`
                      : "/placeholder.jpg"
                  }
                  logo={t.logo[0]?.url}
                  nombre={t.nombre}
                  empresa={t.empresa}
                  cargo={t.marca}
                  texto={t.descripcion}
                />
              </div>
            ))}
          </TinySlider>
        </div>
      </div>
    </section>
  );
}
